import React from 'react';
import { Route } from 'react-router-dom';

import PrivateRoute from './PrivateRoute';

import AdministracionPlanCuenta from '../modules/administracion/PlanCuenta/Index';
import AdministracionProyecto from '../modules/administracion/Proyecto/Index';
import AdministracionBanco from '../modules/administracion/Banco/Index';
import AdministracionCuenta from '../modules/administracion/Cuenta/Index';
import AdministracionCliente from '../modules/administracion/Cliente/Index';
import AdministracionVendedor from '../modules/administracion/Vendedor/Index';
import AdministracionProducto from '../modules/administracion/Producto/Index';
import AdministracionServicio from '../modules/administracion/Servicio/Index';
import AdministracionEstablecimiento from '../modules/administracion/Establecimiento/Index';
import AdministracionAlmacen from '../modules/administracion/Almacen/Index';
import AdministracionExistencia from '../modules/administracion/Existencia/Index';
import AdministracionUnidadMedida from '../modules/administracion/UnidadMedida/Index';
import AdministracionMarca from '../modules/administracion/Marca/Index';
import AdministracionModelo from '../modules/administracion/Modelo/Index';
import AdministracionAtributo from '../modules/administracion/Atributo/Index';
import AdministracionImpresionEtiqueta from '../modules/administracion/ImpresionEtiqueta/Index';
import AdministracionNivel from '../modules/administracion/Nivel/Index';
import AdministracionFenologica from '../modules/administracion/Fenologica/Index';
import AdministracionCreditoInteres from '../modules/administracion/CreditoInteres/Index';

import AdministracionDetraccion from '../modules/administracion/Detraccion/Index';
import AdministracionListaPrecio from '../modules/administracion/ListaPrecio/Index';
import AdministracionProveedor from '../modules/administracion/Proveedor/Index';
import AdministracionEntidad from '../modules/administracion/Entidad/Index';
import AdministracionEmpleado from '../modules/administracion/Empleado/Index';
import AdministracionTipoCambio from '../modules/administracion/TipoCambio/Index';
import AdministracionMetodoPago from '../modules/administracion/MetodoPago/Index';
import AdministracionCaja from '../modules/administracion/Caja/Index';
import AdministracionPlanContable from '../modules/administracion/PlanContable/Index';
import AdministracionDocumento from '../modules/administracion/Documento/Index';

import VentasFactura from '../modules/Ventas/Factura/Index';
import VentasBoleta from '../modules/Ventas/Boleta/Index';
import VentasNotaCredito from '../modules/Ventas/NotaCredito/Index';
import VentasNotaDebito from '../modules/Ventas/NotaDebito/Index';
import VentaCliente from '../modules/Ventas/VentaCliente/Index';
import VentaEstablecimiento from '../modules/Ventas/VentaEstablecimiento/Index';
import VentaControlGuia from '../modules/Ventas/VentaControlGuia-Remision/Index';
import VentaUtilidad from '../modules/Ventas/VentaUtilidad/Index';

import VentaClienteProducto from '../modules/Ventas/VentaClienteProducto/Index';
import VentasCredito from '../modules/credito cobranza/Credito/Index';
import VentasCreditoCliente from '../modules/credito cobranza/CreditoCliente/Index';


import VentaProducto from '../modules/Ventas/VentaProducto/Index';
import VentaVendedor from '../modules/Ventas/VentaVendedor/Index';
import RegistroVenta from '../modules/Ventas/RegistroVenta/Index';
import RegistroVentaSire from '../modules/Ventas/RegistroVentaSire/Index';

import Dashboard from '../modules/Ventas/Dashboard/Index';
import VentasCotizacion from '../modules/Ventas/Cotizacion/Index';
import VentasPedido from '../modules/Ventas/Pedido/Index';
import NotaVenta from '../modules/Ventas/NotaVenta/Index';
import DashboardEstablecimiento from '../modules/Ventas/DashboardEstablecimiento/Index';
import DashboardCliente from '../modules/Ventas/DashboardCliente/Index';
import DashboardVendedor from '../modules/Ventas/DashboardVendedor/Index';
import DashboardProducto from '../modules/Ventas/DashboardProducto/Index';
import Retencion from '../modules/Ventas/Retencion/Index';
import ReporteComprobantes from '../modules/Ventas/ReporteComprobantes/Index';
import ResumenDiario from '../modules/Ventas/ResumenDiario/Index';
import DashboardResumen from '../modules/Ventas/DashboardResumen/Index';
import DashboardGeneral from '../modules/Ventas/DashboardGeneral/Index';

import DashboardDeudaCobrar from '../modules/tesoreria/DashboardDeudaCobrar/Index';
import DashboardDeudaPagar from '../modules/tesoreria/DashboardDeudaPagar/Index';


import LogisticaServicioImportacion from '../modules/logistica/ServicioImportacion/Index';
import LogisticaConcepto from '../modules/logistica/Concepto/Index';
import LogisticaServicioTransformacion from '../modules/logistica/ServicioTransformacion/Index';
import LogisticaUbicacion from '../modules/logistica/Ubicacion/Index';
import LogisticaRequerimiento from '../modules/logistica/Requerimiento/Index';
import LogisticaRequerimientoAprobacion from '../modules/logistica/RequerimientoAprobacion/Index';
import LogisticaOrdenCompra from '../modules/logistica/OrdenCompra/Index';
import LogisticaOrdenServicio from '../modules/logistica/OrdenServicio/Index';
import LogisticaOrdenServicioAprobacion from '../modules/logistica/OrdenServicioAprobacion/Index';
import LogisticaOrdenCompraAprobacion from '../modules/logistica/OrdenCompraAprobacion/Index';
import LogisticaOrdenProduccion from '../modules/logistica/OrdenProduccion/Index';
import LogisticaOrdenProduccionAprobacion from '../modules/logistica/OrdenProduccionAprobacion/Index';
import LogisticaIngreso from '../modules/logistica/Ingreso/Index';
import LogisticaSalida from '../modules/logistica/Salida/Index';
import LogisticaTransferencia from '../modules/logistica/Transferencia/Index';
import LogisticaGuiaRemision from '../modules/logistica/GuiaRemision/Index';
import LogisticaImportacion from '../modules/logistica/Importacion/Index';
import LogisticaReporteGuiaRemision from '../modules/logistica/ReporteGuia-Remision/Index';
import DashboardCompra from '../modules/logistica/DashboardCompra/Index';
import DashboardInventario from '../modules/logistica/DashboardInventario/Index';


import Kardex from '../modules/logistica/Kardex/Index';
import Inventario from '../modules/logistica/Inventario/Index';
import ReporteGeneral from '../modules/logistica/ReporteGeneral/Index';
import LogisticaVehiculo from '../modules/logistica/Vehiculo/Index';
import LogisticaChofer from '../modules/logistica/Chofer/Index';
import LogisticaTransporte from '../modules/logistica/Transporte/Index';
import Compra from '../modules/logistica/Compra/Index';
import RegistroCompra from '../modules/logistica/RegistroCompra/Index';
import CompraProveedor from '../modules/logistica/CompraProveedor/Index';
import LogisticaRequerimientoProduccion from '../modules/logistica/RequerimientoProduccion/Index';
import LogisticaRecetaProduccion from '../modules/logistica/RecetaProduccion/Index';
import Honorario from '../modules/logistica/Honorario/Index';
import ReporteOrdenCompra from '../modules/logistica/ReporteOrdenCompra/Index';
import GuiaTransportista from '../modules/logistica/GuiaTransportista/Index';
import CompraEstablecimiento from '../modules/logistica/CompraEstablecimiento/Index';
import CompraProducto from '../modules/logistica/CompraProducto/Index';
import ReporteStock from '../modules/logistica/ReporteStock/Index';
import ReporteRotacion from '../modules/logistica/ReporteRotacion/Index';
import ReporteProductoVencer from '../modules/logistica/ReporteProductoVencer/Index';
import ReporteTrazabilidad from '../modules/logistica/ReporteTrazabilidad/Index';


import TesoreriaFondoFijo from '../modules/tesoreria/FondoFijo/Index';
import TesoreriaCentroCosto from '../modules/tesoreria/CentroCosto/Index';

import ReporteCuentasCobrar from '../modules/credito cobranza/ReporteCuentasCobrar/Index';
import TesoreriaReportePago from '../modules/tesoreria/ReportePago/Index';
import TesoreriaReporteCuentaPagar from '../modules/tesoreria/ReporteCuentaPagar/Index';

import TesoreriaReporteCobranza from '../modules/tesoreria/ReporteCobranza/Index';
import TesoreriaCuentaCobrada from '../modules/credito cobranza/CuentaCobrada/Index';
import TesoreriaCuentaCancelada from '../modules/tesoreria/CuentaCancelada/Index';
import TesoreriaReporteCuentaCobrar from '../modules/tesoreria/ReporteCuentaCobrar/Index';

import TesoreriaGestionCaja from '../modules/tesoreria/GestionCaja/Index';
import TesoreriaCobranza from '../modules/tesoreria/Cobranza/Index';
import TesoreriaPago from '../modules/tesoreria/Pago/Index';
import TesoreriaArqueoCaja from '../modules/tesoreria/ArqueoCaja/Index';

import CajaChica from '../modules/tesoreria/CajaChica/Index';


import SeguridadUsuario from '../modules/seguridad/Usuario/Index';
import SeguridadRol from '../modules/seguridad/Rol/Index';
import SeguridadAcceso from '../modules/seguridad/Acceso/Index';
import SeguridadUsuarioConfiguracion from '../modules/seguridad/UsuarioConfiguracion/Index';

import Empresa from '../pages/Empresa/Index';
import Parametro from '../pages/Parametro/Index';
import CambiarContrasenia from '../pages/CambiarContrasenia/Index';
import Perfil from '../pages/Perfil/Index';
import FormatoPdf from '../pages/FormatoPdf/Index';

export default class Routers extends React.Component {
    render() {
        return (
            <PrivateRoute>
                <Route exact path="/" />
                <Route exact path="/mi-empresa" render={() => (<Empresa />)} />
                <Route exact path="/parametro" render={() => (<Parametro />)} />
                <Route exact path="/mi-perfil" render={() => (<Perfil />)} />
                <Route exact path="/mi-configuracion" render={() => (<FormatoPdf />)} />
                <Route exact path="/cambiar-contrasenia" render={() => (<CambiarContrasenia />)} />

                <Route exact path="/administracion/plan-cuenta"
                    render={() => (<AdministracionPlanCuenta onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/plan-cuenta")} />)} />
                <Route exact path="/administracion/proyecto"
                    render={() => (<AdministracionProyecto onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/proyecto")} />)} />
                <Route exact path="/administracion/banco"
                    render={() => (<AdministracionBanco onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/banco")} />)} />
                <Route exact path="/administracion/cuenta"
                    render={() => (<AdministracionCuenta onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/cuenta")} />)} />
                <Route exact path="/administracion/cliente"
                    render={() => (<AdministracionCliente onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/cliente")} />)} />
                <Route exact path="/administracion/vendedor"
                    render={() => (<AdministracionVendedor onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/vendedor")} />)} />
                <Route exact path="/administracion/producto"
                    render={() => (<AdministracionProducto onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/producto")} />)} />
                <Route exact path="/administracion/servicio"
                    render={() => (<AdministracionServicio onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/servicio")} />)} />
                <Route exact path="/administracion/establecimiento"
                    render={() => (<AdministracionEstablecimiento onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/establecimiento")} />)} />
                <Route exact path="/administracion/almacen"
                    render={() => (<AdministracionAlmacen onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/almacen")} />)} />
                <Route exact path="/administracion/nivel"
                    render={() => (<AdministracionNivel onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/nivel")} />)} />

                <Route exact path="/administracion/fenologica"
                    render={() => (<AdministracionFenologica onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/fenologica")} />)} />

                <Route exact path="/administracion/credito-interes"
                    render={() => (<AdministracionCreditoInteres onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/credito-interes")} />)} />

                <Route exact path="/administracion/existencia"
                    render={() => (<AdministracionExistencia onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/existencia")} />)} />
                <Route exact path="/administracion/unidad-medida"
                    render={() => (<AdministracionUnidadMedida onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/unidad-medida")} />)} />
                <Route exact path="/administracion/marca"
                    render={() => (<AdministracionMarca onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/marca")} />)} />
                <Route exact path="/administracion/detraccion"
                    render={() => (<AdministracionDetraccion onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/detraccion")} />)} />
                <Route exact path="/administracion/lista-precio"
                    render={() => (<AdministracionListaPrecio onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/lista-precio")} />)} />
                <Route exact path="/administracion/proveedor"
                    render={() => (<AdministracionProveedor onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/proveedor")} />)} />
                <Route exact path="/administracion/entidad"
                    render={() => (<AdministracionEntidad onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/entidad")} />)} />
                <Route exact path="/administracion/empleado"
                    render={() => (<AdministracionEmpleado onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/empleado")} />)} />
                <Route exact path="/administracion/tipo-cambio"
                    render={() => (<AdministracionTipoCambio onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/tipo-cambio")} />)} />
                <Route exact path="/administracion/metodo-pago"
                    render={() => (<AdministracionMetodoPago onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/metodo-pago")} />)} />
                <Route exact path="/administracion/caja"
                    render={() => (<AdministracionCaja onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/caja")} />)} />
                <Route exact path="/administracion/modelo"
                    render={() => (<AdministracionModelo onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/modelo")} />)} />
                <Route exact path="/administracion/plan-contable"
                    render={() => (<AdministracionPlanContable onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/plan-contable")} />)} />

                <Route exact path="/administracion/atributo"
                    render={() => (<AdministracionAtributo onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/atributo")} />)} />

                <Route exact path="/administracion/etiqueta"
                    render={() => (<AdministracionImpresionEtiqueta onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/etiqueta")} />)} />

                <Route exact path="/administracion/documento"
                    render={() => (<AdministracionDocumento onSetBreadcrumb={() => this.props.onSetBreadcrumb("/administracion/documento")} />)} />


                <Route exact path="/ventas/factura"
                    render={() => (<VentasFactura onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/factura")} />)} />
                <Route exact path="/ventas/boleta"
                    render={() => (<VentasBoleta onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/boleta")} />)} />
                <Route exact path="/ventas/nota-credito"
                    render={() => (<VentasNotaCredito onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/nota-credito")} />)} />
                <Route exact path="/ventas/nota-debito"
                    render={() => (<VentasNotaDebito onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/nota-debito")} />)} />
                <Route exact path="/ventas/ventas-cliente"
                    render={() => (<VentaCliente onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/ventas-cliente")} />)} />
                <Route exact path="/ventas/ventas-producto"
                    render={() => (<VentaProducto onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/ventas-producto")} />)} />
                <Route exact path="/ventas/ventas-vendedor"
                    render={() => (<VentaVendedor onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/ventas-producto")} />)} />

                <Route exact path="/ventas/control-credito"
                    render={() => (<VentasCredito onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/control-credito")} />)} />


                <Route exact path="/ventas/credito-cliente"
                    render={() => (<VentasCreditoCliente onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/credito-cliente")} />)} />

                <Route exact path="/ventas/ventas-guia-remision"
                    render={() => (<VentaControlGuia onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/ventas-guia-remision")} />)} />

                <Route exact path="/ventas/ventas-establecimiento"
                    render={() => (<VentaEstablecimiento onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/ventas-establecimiento")} />)} />

                <Route exact path="/ventas/ventas-cliente-producto"
                    render={() => (<VentaClienteProducto onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/ventas-cliente-producto")} />)} />

                <Route exact path="/ventas/ventas-utilidad"
                    render={() => (<VentaUtilidad onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/ventas-utilidad")} />)} />


                <Route exact path="/ventas/registro-venta"
                    render={() => (<RegistroVenta onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/registro-venta")} />)} />

                <Route exact path="/ventas/registro-venta-sire"
                    render={() => (<RegistroVentaSire onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/registro-venta-sire")} />)} />
                <Route exact path="/ventas/dashboard"
                    render={() => (<Dashboard onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/dashboard")} />)} />
                <Route exact path="/ventas/cotizacion"
                    render={() => (<VentasCotizacion onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/cotizacion")} />)} />
                <Route exact path="/ventas/dashboard-establecimiento"
                    render={() => (<DashboardEstablecimiento onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/dashboard-establecimiento")} />)} />
                <Route exact path="/ventas/dashboard-cliente"
                    render={() => (<DashboardCliente onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/dashboard-cliente")} />)} />
                <Route exact path="/ventas/dashboard-vendedor"
                    render={() => (<DashboardVendedor onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/dashboard-vendedor")} />)} />
                <Route exact path="/ventas/dashboard-producto"
                    render={() => (<DashboardProducto onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/dashboard-producto")} />)} />

                <Route exact path="/ventas/dashboard-resumen"
                    render={() => (<DashboardResumen onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/dashboard-resumen")} />)} />

                <Route exact path="/ventas/resumen-general"
                    render={() => (<DashboardGeneral onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/resumen-general")} />)} />

                <Route exact path="/ventas/pedido"
                    render={() => (<VentasPedido onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/pedido")} />)} />
                <Route exact path="/ventas/nota-venta"
                    render={() => (<NotaVenta onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/nota-venta")} />)} />
                <Route exact path="/ventas/retencion"
                    render={() => (<Retencion onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/retencion")} />)} />

                <Route exact path="/ventas/comprobantes"
                    render={() => (<ReporteComprobantes onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/comprobantes")} />)} />

                <Route exact path="/ventas/resumen-diario"
                    render={() => (<ResumenDiario onSetBreadcrumb={() => this.props.onSetBreadcrumb("/ventas/resumen-diario")} />)} />

                <Route exact path="/logistica/servicio-importacion"
                    render={() => (<LogisticaServicioImportacion onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/servicio-importacion")} />)} />
                <Route exact path="/logistica/concepto"
                    render={() => (<LogisticaConcepto onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/concepto")} />)} />
                <Route exact path="/logistica/servicio-transformacion"
                    render={() => (<LogisticaServicioTransformacion onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/servicio-transformacion")} />)} />
                <Route exact path="/logistica/ubicacion"
                    render={() => (<LogisticaUbicacion onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/ubicacion")} />)} />
                <Route exact path="/logistica/requerimiento"
                    render={() => (<LogisticaRequerimiento onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/requerimiento")} />)} />
                <Route exact path="/logistica/solicitud-aprobacion"
                    render={() => (<LogisticaRequerimientoAprobacion onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/solicitud-aprobacion")} />)} />
                <Route exact path="/logistica/orden-compra"
                    render={() => (<LogisticaOrdenCompra onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/orden-compra")} />)} />

                <Route exact path="/logistica/orden-servicio"
                    render={() => (<LogisticaOrdenServicio onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/orden-servicio")} />)} />
                <Route exact path="/logistica/orden-servicio-aprobacion"
                    render={() => (<LogisticaOrdenServicioAprobacion onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/orden-servicio-aprobacion")} />)} />

                <Route exact path="/logistica/adquisicion-aprobacion"
                    render={() => (<LogisticaOrdenCompraAprobacion onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/adquisicion-aprobacion")} />)} />

                <Route exact path="/logistica/orden-produccion"
                    render={() => (<LogisticaOrdenProduccion onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/orden-produccion")} />)} />

                <Route exact path="/logistica/orden-produccion-aprobacion"
                    render={() => (<LogisticaOrdenProduccionAprobacion onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/orden-produccion-aprobacion")} />)} />

                <Route exact path="/logistica/dashboard-compra"
                    render={() => (<DashboardCompra onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/dashboard-compra")} />)} />

                <Route exact path="/logistica/dashboard-inventario"
                    render={() => (<DashboardInventario onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/dashboard-inventario")} />)} />


                <Route exact path="/logistica/vehiculo"
                    render={() => (<LogisticaVehiculo onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/vehiculo")} />)} />
                <Route exact path="/logistica/chofer"
                    render={() => (<LogisticaChofer onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/chofer")} />)} />
                <Route exact path="/logistica/transporte"
                    render={() => (<LogisticaTransporte onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/transporte")} />)} />

                <Route exact path="/logistica/ingresos"
                    render={() => (<LogisticaIngreso onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/ingresos")} />)} />
                <Route exact path="/logistica/salidas"
                    render={() => (<LogisticaSalida onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/salidas")} />)} />
                <Route exact path="/logistica/transferencia"
                    render={() => (<LogisticaTransferencia onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/transferencia")} />)} />
                <Route exact path="/logistica/guia-remision"
                    render={() => (<LogisticaGuiaRemision onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/guia-remision")} />)} />
                <Route exact path="/logistica/importacion"
                    render={() => (<LogisticaImportacion onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/importacion")} />)} />
                <Route exact path="/logistica/kardex"
                    render={() => (<Kardex onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/kardex")} />)} />
                <Route exact path="/logistica/inventario"
                    render={() => (<Inventario onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/inventario")} />)} />
                <Route exact path="/logistica/reporte-general"
                    render={() => (<ReporteGeneral onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/reporte-general")} />)} />
                <Route exact path="/logistica/compra"
                    render={() => (<Compra onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/compra")} />)} />
                <Route exact path="/logistica/registro-compra"
                    render={() => (<RegistroCompra onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/registro-compra")} />)} />
                <Route exact path="/logistica/compra-proveedor"
                    render={() => (<CompraProveedor onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/compra-proveedor")} />)} />
                <Route exact path="/logistica/requerimiento-produccion"
                    render={() => (<LogisticaRequerimientoProduccion onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/requerimiento-produccion")} />)} />
                <Route exact path="/logistica/reporte-orden-compra"
                    render={() => (<ReporteOrdenCompra onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/reporte-orden-compra")} />)} />
                <Route exact path="/logistica/guia-transportista"
                    render={() => (<GuiaTransportista onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/guia-transportista")} />)} />
                <Route exact path="/logistica/receta-produccion"
                    render={() => (<LogisticaRecetaProduccion onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/receta-produccion")} />)} />
                <Route exact path="/logistica/honorario"
                    render={() => (<Honorario onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/honorario")} />)} />
                <Route exact path="/logistica/compra-establecimiento"
                    render={() => (<CompraEstablecimiento onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/compra-establecimiento")} />)} />
                <Route exact path="/logistica/compra-producto"
                    render={() => (<CompraProducto onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/compra-producto")} />)} />

                <Route exact path="/logistica/reporte-stock"
                    render={() => (<ReporteStock onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/reporte-stock")} />)} />

                <Route exact path="/logistica/reporte-rotacion"
                    render={() => (<ReporteRotacion onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/reporte-rotacion")} />)} />

                <Route exact path="/logistica/reporte-por-vencer"
                    render={() => (<ReporteProductoVencer onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/reporte-por-vencer")} />)} />

                <Route exact path="/logistica/reporte-trazabilidad"
                    render={() => (<ReporteTrazabilidad onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/reporte-trazabilidad")} />)} />

                <Route exact path="/logistica/reporte-guia-remision"
                    render={() => (<LogisticaReporteGuiaRemision onSetBreadcrumb={() => this.props.onSetBreadcrumb("/logistica/reporte-guia-remision")} />)} />


                <Route exact path="/tesoreria/fondo-fijo"
                    render={() => (<TesoreriaFondoFijo onSetBreadcrumb={() => this.props.onSetBreadcrumb("/tesoreria/fondo-fijo")} />)} />

                <Route exact path="/tesoreria/centro-costo"
                    render={() => (<TesoreriaCentroCosto onSetBreadcrumb={() => this.props.onSetBreadcrumb("/tesoreria/centro-costo")} />)} />

                <Route exact path="/tesoreria/cuentas-cobranza"
                    render={() => (<TesoreriaReporteCobranza onSetBreadcrumb={() => this.props.onSetBreadcrumb("/tesoreria/cuentas-cobranza")} />)} />

                <Route exact path="/tesoreria/cuentas-por-cobrar"
                    render={() => (<TesoreriaReporteCuentaCobrar onSetBreadcrumb={() => this.props.onSetBreadcrumb("/tesoreria/cuentas-por-cobrar")} />)} />

                <Route exact path="/tesoreria/cuentas-cobradas"
                    render={() => (<TesoreriaCuentaCobrada onSetBreadcrumb={() => this.props.onSetBreadcrumb("/tesoreria/cuentas-cobradas")} />)} />

                <Route exact path="/tesoreria/cuentas-canceladas"
                    render={() => (<TesoreriaCuentaCancelada onSetBreadcrumb={() => this.props.onSetBreadcrumb("/tesoreria/cuentas-canceladas")} />)} />

                <Route exact path="/tesoreria/reporte-cuentas-cobrar"
                    render={() => (<ReporteCuentasCobrar onSetBreadcrumb={() => this.props.onSetBreadcrumb("/tesoreria/reporte-cuentas-cobrar")} />)} />

                <Route exact path="/tesoreria/cuentas-pago"
                    render={() => (<TesoreriaReportePago onSetBreadcrumb={() => this.props.onSetBreadcrumb("/tesoreria/cuentas-pago")} />)} />

                <Route exact path="/tesoreria/cuentas-por-pagar"
                    render={() => (<TesoreriaReporteCuentaPagar onSetBreadcrumb={() => this.props.onSetBreadcrumb("/tesoreria/cuentas-por-pagar")} />)} />

                <Route exact path="/tesoreria/gestion-caja"
                    render={() => (<TesoreriaGestionCaja onSetBreadcrumb={() => this.props.onSetBreadcrumb("/tesoreria/gestion-caja")} />)} />

                <Route exact path="/tesoreria/cobranza"
                    render={() => (<TesoreriaCobranza onSetBreadcrumb={() => this.props.onSetBreadcrumb("/tesoreria/cobranza")} />)} />

                <Route exact path="/cobranza/dashboard-deuda"
                    render={() => (<DashboardDeudaCobrar onSetBreadcrumb={() => this.props.onSetBreadcrumb("/cobranza/dashboard-deuda")} />)} />

                <Route exact path="/pago/dashboard-deuda"
                    render={() => (<DashboardDeudaPagar onSetBreadcrumb={() => this.props.onSetBreadcrumb("/pago/dashboard-deuda")} />)} />

                <Route exact path="/tesoreria/pago"
                    render={() => (<TesoreriaPago onSetBreadcrumb={() => this.props.onSetBreadcrumb("/tesoreria/pago")} />)} />


                <Route exact path="/tesoreria/arqueo-caja"
                    render={() => (<TesoreriaArqueoCaja onSetBreadcrumb={() => this.props.onSetBreadcrumb("/tesoreria/arqueo-caja")} />)} />

                <Route exact path="/tesoreria/caja-chica"
                    render={() => (<CajaChica onSetBreadcrumb={() => this.props.onSetBreadcrumb("/tesoreria/caja-chica")} />)} />

                <Route exact path="/seguridad/usuario"
                    render={() => (<SeguridadUsuario onSetBreadcrumb={() => this.props.onSetBreadcrumb("/seguridad/usuario")} />)} />
                <Route exact path="/seguridad/rol"
                    render={() => (<SeguridadRol onSetBreadcrumb={() => this.props.onSetBreadcrumb("/seguridad/rol")} />)} />
                <Route exact path="/seguridad/acceso"
                    render={() => (<SeguridadAcceso onSetBreadcrumb={() => this.props.onSetBreadcrumb("/seguridad/acceso")} />)} />

                <Route exact path="/seguridad/usuario-configuracion"
                    render={() => (<SeguridadUsuarioConfiguracion onSetBreadcrumb={() => this.props.onSetBreadcrumb("/seguridad/usuario-configuracion")} />)} />
            </PrivateRoute>
        );
    }
}